import React from 'react';

const NavigationMap = () => {
    return (
        <div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3651.7528915848225!2d90.37338351481536!3d23.75618978458647!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b8aca568828b%3A0xe190915b6958a57!2sDhanmondi%2027%20No%20Bus%20Stop!5e0!3m2!1sen!2sbd!4v1619847537556!5m2!1sen!2sbd" width="100%" height="400"></iframe>
        </div>
    );
};

export default NavigationMap;